import React, { useState, useEffect, useContext, useCallback, useMemo, useRef } from 'react';
import { Line } from 'react-chartjs-2';
import './css/TechnicalSheetHTML.css';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartPDFExporter from './ChartPDFExporter';
import CustomToast from '../Toast/CustomToast';
import { UserContext } from '../../../contexts/UserContext';
import SaveDataButton from '../ActionsButtons/SaveDataButton';
import { Button, message, Select } from 'antd';
import WearSummaryTable from './WearSummaryTable';
import WearTrendChart from './WearTrendChart';
import { getWearSumary } from '../../../utils/api';
import HeaderWithInfo from '../HeaderWithInfo';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const App = ({ inspectionData }) => {
  const inspection_date = new Date(inspectionData.inspection_date).toISOString().slice(0, 10);
  console.log("data_by_column ", inspectionData?.data_by_column)

  const [notes, setNotes] = useState(inspectionData?.notes);
  const [wearRows, setWearRows] = useState(null);
  const [recentSummary, setRecentSummary] = useState(null);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [copySource, setCopySource] = useState('');
  const prevSelectedRef = useRef([]);
  const handleRowsChange = useCallback((rowsJson) => {
    setWearRows(rowsJson);
  }, []);


  if (!inspectionData) {
    return <div>No inspection data available yet.</div>;
  }


  const { showToast } = useContext(UserContext);
  const headers = [
    { label: 'FEH', colspan: 4 },
    { label: 'SHELL RING', colspan: 16 },
    { label: 'DEH', colspan: 4 },
  ];

  const subHeaders = [
    { label: 'All dimension should be in mm', className: 'text-left font-bold' },
    { label: 'OUTER' },
    { label: 'MID' },
    { label: 'INNER' },
    { label: '1' },
    { label: '2' },
    { label: '3' },
    { label: '4' },
    { label: '5' },
    { label: '6' },
    { label: '7' },
    { label: '8' },
    { label: '9' },
    { label: '10' },
    { label: '11' },
    { label: '12' },
    { label: '13' },
    { label: '14' },
    { label: '15' },
    { label: '16' },
    { label: 'OUTER' },
    { label: 'MID' },
    { label: 'INNER' },
  ];

  const columnHeaders = [
    { label: 'FEH:OUTER' },
    { label: 'FEH:MID' },
    { label: 'FEH:INNER' },
    { label: 'SHELL RING:1' },
    { label: 'SHELL RING:2' },
    { label: 'SHELL RING:3' },
    { label: 'SHELL RING:4' },
    { label: 'SHELL RING:5' },
    { label: 'SHELL RING:6' },
    { label: 'SHELL RING:7' },
    { label: 'SHELL RING:8' },
    { label: 'SHELL RING:9' },
    { label: 'SHELL RING:10' },
    { label: 'SHELL RING:11' },
    { label: 'SHELL RING:12' },
    { label: 'SHELL RING:13' },
    { label: 'SHELL RING:14' },
    { label: 'SHELL RING:15' },
    { label: 'SHELL RING:16' },
    { label: 'DEH:OUTER' },
    { label: 'DEH:MID' },
    { label: 'DEH:INNER' },
  ];

  // State initialization
  const createValuesArray = () => Array.from({ length: 22 }, () => Math.floor(Math.random() * 300).toString());

  const [keyValueData, setKeyValueData] = useState([
    { key: 'Support Leg:', values: Array(22).fill('115') },
    { key: 'Nail Size:', values: Array(22).fill('100') },
    { key: 'Sublining:', values: Array(22).fill('0') },
    { key: 'Steel Backing', values: Array(22).fill('0') },
  ]);

  const [operatingDetailsData, setOperatingDetailsData] = useState([
    { key: 'Installation Date: Lifter', values: Array(22).fill('') },
    { key: 'Installation Date: Plate', values: Array(22).fill('') },
    { key: 'Total Running Hours: Lifter', values: Array(22).fill('') },
    { key: 'Total Tons Processed: Lifter', values: Array(22).fill('') },
    { key: 'Total Running Hours: Plate', values: Array(22).fill('') },
    { key: 'Total Tons Processed: Plate', values: Array(22).fill('') },
  ]);

  const [lifterPlateDetails, setLifterPlateDetails] = useState([
    { key: 'Lifter width', values: Array(22).fill('') },
    { key: 'Lifter height', values: Array(22).fill('') },
    { key: 'H2A Point', values: Array(22).fill('') },
    { key: 'Face Angle Leading', values: Array(22).fill('') },
    { key: 'Face Angle Trailing', values: Array(22).fill('') },
    { key: 'Reline Limit [Lifter]', values: Array(22).fill('') },
  ]);

  const [plateDetails, setPlateDetails] = useState([
    { key: 'Plate Thickness[Leading]', values: Array(22).fill('') },
    { key: 'Plate Thickness[Trailing]', values: Array(22).fill('') },
    { key: 'Reline Limit [Plate]', values: Array(22).fill('') },
  ]);

  const [measuredDistance, setMeasuredDistance] = useState([
    { key: 'Measured distance from FE/DE:', values: Array(22).fill('') }
  ]);

  const [measurementData, setMeasurementData] = useState([
    { key: 'Front Nail:', values: Array(22).fill('') },
    { key: 'Middle Nail:', values: Array(22).fill('') },
    { key: 'Back Nail:', values: Array(22).fill('') },
  ]);

  const [lifterMeasurementData, setLifterMeasurementData] = useState([
    { key: 'P1', values: Array(22).fill('') },
    { key: 'P2', values: Array(22).fill('') },
    { key: 'P3', values: Array(22).fill('') },
    { key: 'P4', values: Array(22).fill('') },
    { key: 'P5', values: Array(22).fill('') },
    { key: 'P6', values: Array(22).fill('') },
    { key: 'P7', values: Array(22).fill('') },
    { key: 'P8', values: Array(22).fill('') },
    { key: 'P9', values: Array(22).fill('') },
    { key: 'P10', values: Array(22).fill('') },
  ]);

  const [lifterDataMap, setLifterDataMap] = useState(null);
  const [chartData, setChartData] = useState({});
  const [dataByColumn, setDataByColumn] = useState({});

  // Helper function to convert a string to camelCase
  const toCamelCase = (str) => {
    return str
      .toLowerCase()
      .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase())
      .replace(/[^a-zA-Z0-9]/g, '');
  };

  // Helper function to convert degrees to radians
  const toRadian = (angle) => (angle * Math.PI) / 180;
  const [lisfterList, setLifterList] = useState([]);
  const [disabledMap, setDisabledMap] = useState({});




  // Add this state near your other useState hooks
  const [isReadOnly, setIsReadOnly] = useState(false);

  useEffect(() => {
    setIsReadOnly(!!inspectionData?.data_by_column);
  }, [inspectionData]);






  // Sync lifter width with selected columns
  useEffect(() => {
    if (!lifterDataMap || Object.keys(lifterDataMap).length === 0) return;

    const defaultWidth = Object.keys(lifterDataMap)[0]; // e.g., "140"

    setLifterPlateDetails(prev => {
      const lifterWidthRow = prev.find(row => row.key === 'Lifter width');
      if (!lifterWidthRow) return prev;

      const newValues = lifterWidthRow.values.map((val, colIndex) => {
        const columnLabel = columnHeaders[colIndex]?.label;
        const isSelected = selectedColumns.includes(columnLabel);

        // If column is selected and value is empty → fill with default
        if (isSelected && (!val || val === '')) {
          return defaultWidth;
        }
        // If column was deselected → clear value
        if (!isSelected && val) {
          return '';
        }
        return val;
      });

      return prev.map(row =>
        row.key === 'Lifter width'
          ? { ...row, values: newValues }
          : row
      );
    });

    // Also recompute disabledMap when columns change
    // Removed setTimeout - handled by new useEffect below
  }, [selectedColumns, lifterDataMap]);

  // NEW: Automatically recompute disabledMap whenever lifterPlateDetails changes
  useEffect(() => {
    setDisabledMap(computeDisabledMap(lifterPlateDetails));
  }, [lifterPlateDetails]);



  const isColumnReadOnly = (colLabel) => {
    if (!inspectionData?.data_by_column) return false;
    const camelKey = toCamelCase(colLabel);
    return Object.keys(inspectionData.data_by_column).includes(camelKey);
  };
  const getInputProps = (section, colLabel) => {
    if (!isReadOnly || !section) return null;
    if (!colLabel || !isColumnReadOnly(colLabel)) return null; // ← NEW: allow new columns

    return {
      disabled: true,
      readOnly: true,
      style: { backgroundColor: '#f5f5f5', color: '#999' },
    };
  };




  const getEnabledPins = (lifterWidth) => {
    const width = parseInt(lifterWidth);
    if ([140, 150].includes(width)) return 5; // Enable P1 to P5
    if (width === 165) return 6; // Enable P1 to P6
    if ([200, 205, 210].includes(width)) return 7; // Enable P1 to P7
    if (width === 250) return 8; // Enable P1 to P8
    if (width === 300) return 10; // Enable P1 to P10
    return 5; // Default: Enable P1 to P5
  };

  // Compute disabledMap based on lifter width for each column
  const computeDisabledMap = (lifterPlateDetails) => {
    const map = {};
    const lifterWidthRow = lifterPlateDetails.find(row => row.key === 'Lifter width');

    for (let col = 0; col < 22; col++) {
      const lifterWidth = lifterWidthRow?.values[col] || '';
      const enabledPinCount = getEnabledPins(lifterWidth);

      for (let row = 0; row < 10; row++) { // P1 to P10
        const key = `${row}-${col}`;
        map[key] = row >= enabledPinCount; // Disable rows beyond enabledPinCount
      }
    }

    return map;
  };

  // Modified handleLifterPlateDetailsChange to update disabledMap and clear disabled fields
  // Handle changes to lifter width dropdown
  const handleLifterPlateDetailsChange = (rowIndex, colIndex, e) => {
    const newWidth = e.target.value;

    // Update lifterPlateDetails
    setLifterPlateDetails((prev) => {
      const newDetails = prev.map((row, i) =>
        i === rowIndex
          ? {
            ...row,
            values: row.values.map((val, idx) =>
              idx === colIndex ? newWidth : val
            ),
          }
          : row
      );

      // Update disabledMap based on new lifterPlateDetails
      // Removed manual setDisabledMap - handled by useEffect

      // Clear values for disabled fields in lifterMeasurementData
      const newDisabledMap = computeDisabledMap(newDetails);
      setLifterMeasurementData((prev) =>
        prev.map((row, rowIndex) => {
          const updatedValues = row.values.map((val, valIndex) => {
            const key = `${rowIndex}-${valIndex}`;
            if (valIndex === colIndex && newDisabledMap[key]) {
              return '0'; // Clear value if disabled
            }
            return val;
          });
          return { ...row, values: updatedValues };
        })
      );

      // Autofill pin values for the selected width
      const pinData = lifterDataMap?.[newWidth];
      // if (pinData) {
      //   setLifterMeasurementData((prev) =>
      //     prev.map((row, rowIndex) => {
      //       const pinKey = `pin${row.key.replace(/\D/g, '')}`; // e.g., P1 -> pin1
      //       const pinValue = pinData[pinKey]?.values?.[0] ?? '';
      //       const updatedValues = row.values.map((val, valIndex) => {
      //         const key = `${rowIndex}-${valIndex}`;
      //         if (valIndex === colIndex && !newDisabledMap[key]) {
      //           return Math.round(pinValue).toString();
      //         }
      //         return val;
      //       });
      //       return { ...row, values: updatedValues };
      //     })
      //   );
      // }

      // Removed manual setDisabledMap

      return newDetails;
    });
  };

  useEffect(() => {
    try {
      const apiData = JSON.parse(localStorage.getItem('equipments'));
      if (apiData && Array.isArray(apiData)) {
        const newDataMap = {};

        apiData.forEach((item) => {
          const width = item.lifter_width;
          const pins = {};
          for (let i = 1; i <= 10; i++) {
            const pinKey = `pin${i}`;
            if (item[pinKey]) {
              pins[pinKey] = { values: [parseFloat(item[pinKey])] };
            }
          }
          newDataMap[width] = pins;
        });

        setLifterDataMap(newDataMap);

        const initialWidth = Object.keys(newDataMap)[0];
        if (initialWidth && newDataMap[initialWidth]) {
          // Initialize lifterPlateDetails with initial width
          setLifterPlateDetails((prev) =>
            prev.map((row) =>
              row.key === 'Lifter width'
                ? { ...row, values: Array(22).fill(initialWidth) }
                : row
            )
          );

          // Initialize lifterMeasurementData with pin values
          const filledMeasurements = Array.from({ length: 10 }, (_, i) => {
            const pinKey = `pin${i + 1}`;
            const pinValue = newDataMap[initialWidth][pinKey]?.values?.[0] ?? '';
            const enabledPinCount = getEnabledPins(initialWidth);
            const values = Array(22).fill(i < enabledPinCount ? Math.round(pinValue).toString() : '');
            return {
              key: `P${i + 1}`,
              values,
            };
          });

          setLifterMeasurementData(filledMeasurements);

          // Initialize disabledMap - handled by useEffect
        }
      }
    } catch (error) {
      console.error('Failed to parse data from localStorage:', error);
    }
  }, []);


  // Put this right after the other useEffects (or inside the same useEffect)
  const [lockedColumns, setLockedColumns] = useState([]);

  useEffect(() => {
    if (inspectionData?.data_by_column) {
      const original = Object.keys(inspectionData.data_by_column);
      const labels = original
        .map(key => {
          const h = columnHeaders.find(h => toCamelCase(h.label) === key);
          return h ? h.label : null;
        })
        .filter(Boolean);

      setLockedColumns(labels);          // ← columns that must stay selected
      setSelectedColumns(prev => {
        // keep everything the user already selected + add the locked ones
        const next = new Set([...prev, ...labels]);
        return Array.from(next);
      });
    } else {
      setLockedColumns([]);
    }
  }, [inspectionData]);

  // Auto-copy to new selected columns (existing logic)
  useEffect(() => {
    const prev = prevSelectedRef.current;
    const added = selectedColumns.filter(s => !prev.includes(s));

    if (added.length > 0 && copySource) {
      const sourceIndex = columnHeaders.findIndex(h => h.label === copySource);
      if (sourceIndex === -1) return; // Invalid source

      added.forEach(targetLabel => {
        const targetIndex = columnHeaders.findIndex(h => h.label === targetLabel);
        if (targetIndex !== -1 && sourceIndex !== targetIndex) {
          copyColumnToColumn(sourceIndex, targetIndex);
        }
      });

      showToast(`Auto-copied from "${copySource}" to ${added.length} new column(s)`, 'success');
    }

    prevSelectedRef.current = selectedColumns;
  }, [selectedColumns, copySource]);

  useEffect(() => {
    try {
      // Initialize lifterDataMap from localStorage
      const apiData = JSON.parse(localStorage.getItem('equipments'));
      let newDataMap = {};
      if (apiData && Array.isArray(apiData)) {
        apiData.forEach((item) => {
          const width = item.lifter_width;
          const pins = {};
          for (let i = 1; i <= 10; i++) {
            const pinKey = `pin${i}`;
            if (item[pinKey]) {
              pins[pinKey] = { values: [parseFloat(item[pinKey])] };
            }
          }
          newDataMap[width] = pins;
        });
      }
      setLifterDataMap(newDataMap);

      // Initialize states with data_by_column
      if (inspectionData?.data_by_column) {
        // ← NEW LINE
        setIsReadOnly(true); // <<< disable the three sections
        const dataByColumn = inspectionData.data_by_column;

        // Map columnHeaders to indices
        const columnIndexMap = {};
        columnHeaders.forEach((header, index) => {
          columnIndexMap[toCamelCase(header.label)] = index;
        });

        // Initialize selectedColumns with all columns from data_by_column
        setSelectedColumns(Object.keys(dataByColumn).map((key) => {
          const header = columnHeaders.find(h => toCamelCase(h.label) === key);
          return header ? header.label : key;
        }));

        // Update keyValueData
        setKeyValueData((prev) =>
          prev.map((row) => {
            const camelKey = toCamelCase(row.key);
            const newValues = Array(22).fill('');
            Object.entries(dataByColumn).forEach(([colKey, colData]) => {
              const colIndex = columnIndexMap[colKey];
              if (colIndex !== undefined && colData[camelKey]) {
                newValues[colIndex] = colData[camelKey];
              }
            });
            return { ...row, values: newValues };
          })
        );

        // Update operatingDetailsData
        setOperatingDetailsData((prev) =>
          prev.map((row) => {
            const camelKey = toCamelCase(row.key);
            const newValues = Array(22).fill('');
            Object.entries(dataByColumn).forEach(([colKey, colData]) => {
              const colIndex = columnIndexMap[colKey];
              if (colIndex !== undefined && colData[camelKey]) {
                newValues[colIndex] = colData[camelKey];
              }
            });
            return { ...row, values: newValues };
          })
        );

        // Update lifterPlateDetails
        setLifterPlateDetails((prev) => {
          const newLifterPlateDetails = prev.map((row) => {
            const camelKey = toCamelCase(row.key);
            const newValues = Array(22).fill('');
            Object.entries(dataByColumn).forEach(([colKey, colData]) => {
              const colIndex = columnIndexMap[colKey];
              if (colIndex !== undefined && colData[camelKey]) {
                newValues[colIndex] = colData[camelKey];
              }
            });
            return { ...row, values: newValues };
          });

          // Update disabledMap and lifterMeasurementData based on lifterWidth
          setLifterMeasurementData((prev) => {
            const newLifterMeasurementData = prev.map((row) => {
              const camelKey = toCamelCase(row.key);
              const newValues = Array(22).fill('');
              Object.entries(dataByColumn).forEach(([colKey, colData]) => {
                const colIndex = columnIndexMap[colKey];
                if (colIndex !== undefined && colData[camelKey]) {
                  newValues[colIndex] = colData[camelKey];
                }
              });
              return { ...row, values: newValues };
            });

            // Compute disabledMap based on lifterWidth
            const disabledMap = computeDisabledMap(newLifterPlateDetails);

            // Clear disabled pin values
            const updatedLifterMeasurementData = newLifterMeasurementData.map((row, rowIndex) => {
              const newValues = row.values.map((val, colIndex) => {
                const key = `${rowIndex}-${colIndex}`;
                return disabledMap[key] ? '0' : val;
              });
              return { ...row, values: newValues };
            });

            // Removed setDisabledMap - handled by useEffect
            return updatedLifterMeasurementData;
          });

          // Removed setDisabledMap - handled by useEffect
          return newLifterPlateDetails;
        });

        // Update plateDetails
        setPlateDetails((prev) =>
          prev.map((row) => {
            const camelKey = toCamelCase(row.key);
            const newValues = Array(22).fill('');
            Object.entries(dataByColumn).forEach(([colKey, colData]) => {
              const colIndex = columnIndexMap[colKey];
              if (colIndex !== undefined && colData[camelKey]) {
                newValues[colIndex] = colData[camelKey];
              }
            });
            return { ...row, values: newValues };
          })
        );

        // Update measuredDistance
        setMeasuredDistance((prev) =>
          prev.map((row) => {
            const camelKey = toCamelCase(row.key);
            const newValues = Array(22).fill('');
            Object.entries(dataByColumn).forEach(([colKey, colData]) => {
              const colIndex = columnIndexMap[colKey];
              if (colIndex !== undefined && colData[camelKey]) {
                newValues[colIndex] = colData[camelKey];
              }
            });
            return { ...row, values: newValues };
          })
        );

        // Update measurementData
        setMeasurementData((prev) =>
          prev.map((row) => {
            const camelKey = toCamelCase(row.key);
            const newValues = Array(22).fill('');
            Object.entries(dataByColumn).forEach(([colKey, colData]) => {
              const colIndex = columnIndexMap[colKey];
              if (colIndex !== undefined && colData[camelKey]) {
                newValues[colIndex] = colData[camelKey];
              }
            });
            return { ...row, values: newValues };
          })
        );

        // Initialize dataByColumn
        setDataByColumn(dataByColumn);
      }
      else {
        // This is a NEW inspection → everything editable
        setIsReadOnly(false);
      }
    } catch (error) {
      console.error('Failed to initialize data:', error);
      showToast('Error loading inspection data', 'error');
    }
  }, [inspectionData]);


  // Reset all fields to empty values
  const resetTablesData = () => {
    const resetArray = () => Array(22).fill('');

    setKeyValueData([
      { key: 'Support Leg:', values: resetArray() },
      { key: 'Nail Size:', values: resetArray() },
      { key: 'Sublining:', values: resetArray() },
      { key: 'Steel Backing', values: resetArray() },
    ]);

    setOperatingDetailsData([
      { key: 'Installation Date: Lifter', values: Array(22).fill('') },
      { key: 'Installation Date: Plate', values: Array(22).fill('') },
      { key: 'Total Running Hours: Lifter', values: Array(22).fill('') },
      { key: 'Total Tons Processed: Lifter', values: Array(22).fill('') },
      { key: 'Total Running Hours: Plate', values: Array(22).fill('') },
      { key: 'Total Tons Processed: Plate', values: Array(22).fill('') },
    ]);

    setLifterPlateDetails([
      { key: 'Lifter width', values: resetArray() },
      { key: 'Lifter height', values: resetArray() },
      { key: 'H2A Point', values: resetArray() },
      { key: 'Face Angle Leading', values: resetArray() },
      { key: 'Face Angle Trailing', values: Array(22).fill('0') },
      { key: 'Reline Limit [Lifter]', values: resetArray() },
    ]);

    setPlateDetails([
      { key: 'Plate Thickness[Leading]', values: resetArray() },
      { key: 'Plate Thickness[Trailing]', values: resetArray() },
      { key: 'Reline Limit [Plate]', values: resetArray() },
    ]);

    setMeasuredDistance([
      { key: 'Measured distance from FE/DE:', values: createValuesArray() }
    ]);

    setMeasurementData([
      { key: 'Front Nail:', values: resetArray() },
      { key: 'Middle Nail:', values: resetArray() },
      { key: 'Back Nail:', values: resetArray() },
    ]);

    setLifterMeasurementData([
      { key: 'P1', values: Array(22).fill('') },
      { key: 'P2', values: Array(22).fill('') },
      { key: 'P3', values: Array(22).fill('') },
      { key: 'P4', values: Array(22).fill('') },
      { key: 'P5', values: Array(22).fill('') },
      { key: 'P6', values: Array(22).fill('') },
      { key: 'P7', values: Array(22).fill('') },
      { key: 'P8', values: Array(22).fill('') },
      { key: 'P9', values: Array(22).fill('') },
      { key: 'P10', values: Array(22).fill('') },
    ]);

    setChartData({});
  };

  // Handlers for state updates
  const handleKeyValueChange = (index, colIndex, e) => {
    const newKeyValueData = [...keyValueData];
    newKeyValueData[index].values[colIndex] = e.target.value;
    setKeyValueData(newKeyValueData);
  };



  // Updated handler for operating details with validation
  const handleOperatingDetailsChange = (rowIndex, colIndex, e) => {
    const newValue = e.target.value;

    // Validate Total Running Hours: Lifter (index 2) and Total Running Hours: Plate (index 4)
    if (rowIndex === 2 || rowIndex === 4) {
      const installationDateIndex = rowIndex === 2 ? 0 : 1; // Lifter: 0, Plate: 1
      const installationDate = operatingDetailsData[installationDateIndex].values[colIndex];
      if (!validateRunningHours(rowIndex, colIndex, newValue, installationDate)) {
        return; // Prevent setting invalid value
      }
    }

    const newOperatingDetailsData = [...operatingDetailsData];
    newOperatingDetailsData[rowIndex].values[colIndex] = newValue;
    setOperatingDetailsData(newOperatingDetailsData);
  };

  const handleMeasuredDistanceChange = (index, colIndex, e) => {
    const newMeasuredDistance = [...measuredDistance];
    newMeasuredDistance[index].values[colIndex] = e.target.value;
    setMeasuredDistance(newMeasuredDistance);
  };

  const handlePlateDetailsChange = (index, colIndex, e) => {
    const newPlateDetails = [...plateDetails];
    newPlateDetails[index].values[colIndex] = e.target.value;
    setPlateDetails(newPlateDetails);
  };

  const handleMeasurementChange = (rowIndex, colIndex, e) => {
    const newMeasurementData = [...measurementData];
    newMeasurementData[rowIndex].values[colIndex] = e.target.value;
    setMeasurementData(newMeasurementData);
  };

  const handleLifterMeasurementChange = (rowIndex, colIndex, e) => {
    const newLifterMeasurementData = [...lifterMeasurementData];
    newLifterMeasurementData[rowIndex].values[colIndex] = e.target.value;
    setLifterMeasurementData(newLifterMeasurementData);
  };
  // Validation function for running hours
  const validateRunningHours = (rowIndex, colIndex, value, installationDate) => {
    if (!value || !installationDate) return true; // Skip if no value or no installation date

    const inspectionDateObj = new Date(inspection_date);
    const installationDateObj = new Date(installationDate);

    if (isNaN(installationDateObj.getTime())) {
      showToast(`Invalid installation date in column ${colIndex + 1}`, 'error');
      return false;
    }

    const maxHours = (inspectionDateObj - installationDateObj) / (1000 * 60 * 60); // Difference in hours
    const enteredHours = parseFloat(value);

    if (isNaN(enteredHours) || enteredHours <= maxHours) {
      return true;
    } else {
      showToast(
        `Total Running Hours in column ${colIndex + 1} exceeds maximum allowed (${maxHours.toFixed(2)} hours)`,
        'error'
      );
      return false;
    }
  };
  // Function to export data as JSON and generate chart data
  // === Replace your entire exportDataAsJson function with this ===
  const exportDataAsJson = () => {
    const dataByColumn = {};
    columnHeaders.forEach((header) => {
      dataByColumn[toCamelCase(header.label)] = {};
    });

    // Combine simple key-value data
    const simpleData = [
      ...keyValueData,
      ...lifterPlateDetails,
      ...plateDetails,
      ...measuredDistance,
    ];

    simpleData.forEach((row) => {
      const camelCaseKey = toCamelCase(row.key);
      columnHeaders.forEach((header, colIndex) => {
        const camelCaseHeader = toCamelCase(header.label);
        dataByColumn[camelCaseHeader][camelCaseKey] = row.values[colIndex] || '';
      });
    });

    const arrayData = [...operatingDetailsData, ...measurementData, ...lifterMeasurementData];
    arrayData.forEach((row) => {
      const camelCaseKey = toCamelCase(row.key);
      row.values.forEach((value, colIndex) => {
        if (colIndex < columnHeaders.length) {
          const camelCaseHeader = toCamelCase(columnHeaders[colIndex].label);
          dataByColumn[camelCaseHeader][camelCaseKey] = value;
        }
      });
    });

    // === Validate Running Hours ===
    let hasValidationErrors = false;
    columnHeaders.forEach((header, colIndex) => {
      const lifterHours = operatingDetailsData[2].values[colIndex];
      const plateHours = operatingDetailsData[4].values[colIndex];
      const lifterInstallationDate = operatingDetailsData[0].values[colIndex];
      const plateInstallationDate = operatingDetailsData[1].values[colIndex];

      if (lifterHours && lifterInstallationDate) {
        if (!validateRunningHours(2, colIndex, lifterHours, lifterInstallationDate)) {
          hasValidationErrors = true;
        }
      }
      if (plateHours && plateInstallationDate) {
        if (!validateRunningHours(4, colIndex, plateHours, plateInstallationDate)) {
          hasValidationErrors = true;
        }
      }
    });

    if (hasValidationErrors) {
      showToast('Please correct invalid running hours before generating charts', 'error');
      return;
    }

    // === Human-readable field names ===
    const fieldNameMap = {
      supportLeg: 'Support Leg',
      nailSize: 'Nail Size',
      sublining: 'Sublining',
      steelBacking: 'Steel Backing',
      installationDateLifter: 'Installation Date: Lifter',
      installationDatePlate: 'Installation Date: Plate',
      lifterWidth: 'Lifter width',
      lifterHeight: 'Lifter height',
      h2aPoint: 'H2A Point',
      faceAngleLeading: 'Face Angle Leading',
      faceAngleTrailing: 'Face Angle Trailing',
      relineLimitLifter: 'Reline Limit [Lifter]',
      plateThicknessLeading: 'Plate Thickness[Leading]',
      plateThicknessTrailing: 'Plate Thickness[Trailing]',
      relineLimitPlate: 'Reline Limit [Plate]',
      frontNail: 'Front Nail',
      middleNail: 'Middle Nail',
      backNail: 'Back Nail',
      measuredDistanceFromFeDe: 'Measured distance from FE/DE',
      p1: 'P1', p2: 'P2', p3: 'P3', p4: 'P4', p5: 'P5',
      p6: 'P6', p7: 'P7', p8: 'P8', p9: 'P9', p10: 'P10',
    };

    const getPrettyFieldName = (key) => fieldNameMap[key] || key;
    const getColumnLabel = (key) =>
      columnHeaders.find(h => toCamelCase(h.label) === key)?.label || key;

    // === Generate chart data + validation ===
    const newChartData = {};
    let hasError = false;
    let firstError = null;

    for (const columnKey of Object.keys(dataByColumn)) {
      const columnLabel = getColumnLabel(columnKey);

      // Skip unselected columns
      if (!selectedColumns.includes(columnLabel)) {
        continue;
      }

      const columnData = dataByColumn[columnKey];

      // Extract values
      const sublining = Number(columnData.sublining) || 0;
      const lifterWidth = Number(columnData.lifterWidth) || 0;
      const lifterHeight = Number(columnData.lifterHeight) || 0;
      const h2aPoint = Number(columnData.h2aPoint) || 0;
      const faceAngleLeading = Number(columnData.faceAngleLeading) || 0;
      const faceAngleTrailing = Number(columnData.faceAngleTrailing) || 0;
      const plateThicknessLeading = Number(columnData.plateThicknessLeading) || 0;
      const plateThicknessTrailing = Number(columnData.plateThicknessTrailing) || 0;
      const nailSize = Number(columnData.nailSize) || 0;
      const supportLeg = Number(columnData.supportLeg) || 0;
      const steelBacking = Number(columnData.steelBacking) || 0;
      const frontNail = Number(columnData.frontNail) || 0;
      const middleNail = Number(columnData.middleNail) || 0;
      const backNail = Number(columnData.backNail) || 0;
      const relineLimitLifter = Number(columnData.relineLimitLifter) || 0;
      const relineLimitPlate = Number(columnData.relineLimitPlate) || 0;

      // === Required fields check ===
      const missingFields = [];
      if (!supportLeg) missingFields.push('supportLeg');
      if (!nailSize) missingFields.push('nailSize');
      if (!columnData.installationDateLifter) missingFields.push('installationDateLifter');
      if (!columnData.installationDatePlate) missingFields.push('installationDatePlate');
      if (!lifterWidth) missingFields.push('lifterWidth');
      if (!lifterHeight) missingFields.push('lifterHeight');
      if (!columnData.relineLimitLifter) missingFields.push('relineLimitLifter');
      if (!plateThicknessLeading) missingFields.push('plateThicknessLeading');
      if (!plateThicknessTrailing) missingFields.push('plateThicknessTrailing');
      if (!columnData.relineLimitPlate) missingFields.push('relineLimitPlate');
      if (!frontNail) missingFields.push('frontNail');
      if (!backNail) missingFields.push('backNail');

      for (let i = 1; i <= 10; i++) {
        if (!columnData[`p${i}`]) missingFields.push(`p${i}`);
      }

      if (missingFields.length > 0) {
        hasError = true;
        const firstMissing = missingFields[0];
        const prettyField = getPrettyFieldName(firstMissing);

        // Save first error for scroll
        if (!firstError) {
          firstError = { columnLabel, fieldName: firstMissing, prettyField };
        }

        showToast(
          `Missing required field in "${columnLabel}": ${prettyField}`,
          'error'
        );

        console.warn(`Incomplete data for "${columnLabel}":`, missingFields.map(getPrettyFieldName).join(', '));
        continue; // Skip this column
      }

      // === Wear curve calculations ===
      let backNail_x = 0, backNail_y = 0;
      let middleNail_x = 100;
      let middleNail_y = 0;
      let frontNail_x = 170;
      let frontNail_y = 0;

      let pin_formula = 0;
      if (steelBacking > 0 && sublining > 0) {
        pin_formula = supportLeg + nailSize + steelBacking + sublining;
        frontNail_y = nailSize - frontNail + steelBacking + sublining;
        backNail_y = nailSize - backNail + steelBacking + sublining;
        middleNail_y = nailSize - middleNail + steelBacking + sublining;
      } else if (steelBacking > 0) {
        pin_formula = supportLeg + nailSize + steelBacking;
        frontNail_y = nailSize - frontNail + steelBacking;
        backNail_y = nailSize - backNail + steelBacking;
        middleNail_y = nailSize - middleNail + steelBacking;
      } else {
        pin_formula = supportLeg + nailSize;
        frontNail_y = nailSize - frontNail;
        backNail_y = nailSize - backNail;
        middleNail_y = nailSize - middleNail;
      }

      const nails_x_y = [
        { x: backNail_x, y: backNail_y },
        { x: middleNail_x, y: middleNail_y },
        { x: frontNail_x, y: frontNail_y },
      ];

      const wear_curveA = Object.entries(lifterDataMap[lifterWidth] || {})
        .map(([_, data]) => parseFloat(data.values[0]))
        .map(x => ({ x }));

      const pinKeys = Object.keys(columnData).filter(k => /^p\d+$/.test(k));
      const wear_curveB = pinKeys.map(key => ({
        y: pin_formula - Number(columnData[key])
      }));

      let wear_curve = wear_curveA.map((p, i) => ({
        x: p.x,
        y: wear_curveB[i]?.y ?? 0
      }));
      const maxIndex = getEnabledPins(lifterWidth);
      wear_curve = wear_curve.filter((_, i) => i < maxIndex);

      const yTop = sublining + plateThicknessLeading + h2aPoint;
      const yMax = sublining + lifterHeight;
      const F4 = 200;
      const faceAngleCordinate_X = Math.tan(toRadian(faceAngleLeading)) * (yMax - yTop) + F4;
      const faceAngleCordinate_rear_X = lifterWidth + F4 - Math.tan(toRadian(faceAngleTrailing)) * (yMax - yTop);

      newChartData[columnKey] = {
        labels: pinKeys,
        datasets: [
          {
            label: 'Lifter & Plate details',
            data: [
              { x: 0, y: sublining + plateThicknessTrailing },
              { x: F4, y: sublining + plateThicknessLeading },
              { x: F4, y: yTop },
              { x: faceAngleCordinate_X, y: yMax },
              { x: faceAngleCordinate_rear_X, y: yMax },
              { x: lifterWidth + F4, y: yTop * 1.2 },
              { x: lifterWidth + F4, y: yTop },
              { x: lifterWidth + F4, y: 0 },
              { x: 0, y: 0 },
              { x: 0, y: sublining + plateThicknessTrailing },
            ],
            borderColor: '#262626',
            borderWidth: 2,
            pointRadius: 0.5,
            pointBackgroundColor: '#262626',
            fill: false,
            tension: 0,
          },
          {
            label: 'Wear Curve',
            data: [...nails_x_y, ...wear_curve],
            borderColor: '#b93636',
            borderWidth: 2,
            pointRadius: 0.5,
            pointBackgroundColor: '#b93636',
            tension: 0.3,
            fill: false,
          },
          {
            label: 'Reline limit lifter',
            data: [
              { x: 250, y: relineLimitLifter + sublining },
              { x: lifterWidth + 150, y: relineLimitLifter + sublining }
            ],
            borderColor: '#FF0000',
            borderWidth: 1,
            borderDash: [6, 1],
            pointRadius: 0,
            tension: 0,
            fill: false,
          },
          {
            label: 'Reline limit Plate',
            data: [
              { x: 50, y: relineLimitPlate + sublining },
              { x: 150, y: relineLimitPlate + sublining }
            ],
            borderColor: '#FF0000',
            borderWidth: 1,
            borderDash: [6, 1],
            pointRadius: 0,
            tension: 0,
            fill: false,
          },
        ],
      };

      dataByColumn[columnKey].chartData = newChartData[columnKey];
    }

    // === FINAL CHECK: Block generation if any error ===
    if (hasError) {
      if (firstError) {
        showToast(
          `Missing required field in "${firstError.columnLabel}": ${firstError.prettyField}`,
          'error'
        );

        // Auto-scroll to first missing field
        setTimeout(() => {
          const selector = firstError.fieldName === 'lifterWidth'
            ? `select[value=""]`
            : `input[value=""]`;
          const input = document.querySelector(
            `td:contains("${firstError.columnLabel}") ${selector}`
          );
          const cell = input?.closest('td');
          cell?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          input?.focus();
        }, 300);
      }
      return; // STOP — no charts
    }

    if (Object.keys(newChartData).length === 0) {
      showToast('No selected columns have complete data.', 'error');
      return;
    }

    // === Filter unselected columns ===
    const selectedColumnKeys = selectedColumns.map(col => toCamelCase(col));
    const filteredData = Object.fromEntries(
      Object.entries(dataByColumn).filter(([key]) => selectedColumnKeys.includes(key))
    );

    Object.keys(dataByColumn).forEach(key => {
      if (!selectedColumnKeys.includes(key)) {
        delete newChartData[key];
      }
    });

    setChartData(newChartData);
    setDataByColumn(filteredData);

    showToast('Charts generated successfully!', 'success');
  };

  const options = {
    responsive: true,
    scales: {
      x: {
        type: 'linear',
        title: { display: true, text: 'X Axis (mm)' },
        min: 0,
        max: 500,
      },
      y: {
        title: { display: true, text: 'Y Axis (mm)' },
        min: 0,
        max: 500,
      },
    },
    plugins: {
      legend: { display: true },
    },
  };
  const [originalKeyValueData, setOriginalKeyValueData] = useState([]);
  const fillTextboxes = (e) => {
    const checked = e.target.checked;

    const clearRowValues = (data) =>
      data.map((row) => {
        const newValues = row.values.map((val, i) => i === 0 ? val : '');
        return { ...row, values: newValues };
      });

    const fillRowValues = (data) =>
      data.map((row) => {
        const firstValue = row.values[0];
        const newValues = row.values.map(() => firstValue);
        return { ...row, values: newValues };
      });

    setKeyValueData(checked ? fillRowValues(keyValueData) : clearRowValues(keyValueData));
    setOperatingDetailsData(checked ? fillRowValues(operatingDetailsData) : clearRowValues(operatingDetailsData));
    setLifterPlateDetails(checked ? fillRowValues(lifterPlateDetails) : clearRowValues(lifterPlateDetails));
    setPlateDetails(checked ? fillRowValues(plateDetails) : clearRowValues(plateDetails));
  };

  const copyColumnToColumn = (sourceIndex, targetIndex) => {
    // Update keyValueData
    setKeyValueData(prev =>
      prev.map(row => ({
        ...row,
        values: row.values.map((v, i) => (i === targetIndex ? row.values[sourceIndex] : v))
      }))
    );

    // Update operatingDetailsData
    setOperatingDetailsData(prev =>
      prev.map(row => ({
        ...row,
        values: row.values.map((v, i) => (i === targetIndex ? row.values[sourceIndex] : v))
      }))
    );

    // Update lifterPlateDetails
    const newLifterPlateDetails = lifterPlateDetails.map(row => ({
      ...row,
      values: row.values.map((v, i) => (i === targetIndex ? row.values[sourceIndex] : v))
    }));
    setLifterPlateDetails(newLifterPlateDetails);

    // Compute new disabled map based on updated lifter widths
    const newDisabledMap = computeDisabledMap(newLifterPlateDetails);

    // Update lifterMeasurementData with copy and clear disabled pins
    const newLifterMeasurementData = lifterMeasurementData.map((row, rowIndex) => ({
      ...row,
      values: row.values.map((val, colIndex) => {
        if (colIndex === targetIndex) {
          const key = `${rowIndex}-${targetIndex}`;
          return newDisabledMap[key] ? '0' : row.values[sourceIndex];
        }
        return val;
      })
    }));
    setLifterMeasurementData(newLifterMeasurementData);

    // Update plateDetails
    setPlateDetails(prev =>
      prev.map(row => ({
        ...row,
        values: row.values.map((v, i) => (i === targetIndex ? row.values[sourceIndex] : v))
      }))
    );

    // Update measuredDistance
    setMeasuredDistance(prev =>
      prev.map(row => ({
        ...row,
        values: row.values.map((v, i) => (i === targetIndex ? row.values[sourceIndex] : v))
      }))
    );

    // Update measurementData
    setMeasurementData(prev =>
      prev.map(row => ({
        ...row,
        values: row.values.map((v, i) => (i === targetIndex ? row.values[sourceIndex] : v))
      }))
    );

    // Removed manual Update disabledMap - handled by useEffect
  };

  return (
    <div className="container">
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '20px', marginBottom: '20px' }}>
        <div style={{ minWidth: '320px' }}>
          <p style={{ fontWeight: 'bold', marginBottom: '8px', color: '#333' }}>Display Columns</p>
          <Select
            mode="multiple"
            style={{ width: '300px' }}
            placeholder="Select columns to display"
            value={selectedColumns}
            onChange={setSelectedColumns}
            options={columnHeaders.map(header => ({
              value: header.label,
              label: header.label,
              disabled: lockedColumns.includes(header.label),
            }))}
          />
        </div>
        <div style={{ minWidth: '270px' }}>
          <p style={{ fontWeight: 'bold', marginBottom: '8px', color: '#333' }}><HeaderWithInfo label={'Copy from'} /></p>
          <Select
            style={{ width: '250px' }}
            placeholder="Auto-copy from (optional)"
            value={copySource}
            onChange={setCopySource}
            options={[
              { value: '', label: 'No Copy' },
              ...selectedColumns.map(col => ({ value: col, label: col }))
            ]}
          />
        </div>
      </div>
      {/* === BANNER – shows when editing an existing inspection === */}
      {/* {isReadOnly && (
        <div style={{
          margin: '12px 0',
          padding: '10px',
          backgroundColor: '#fffbe6',
          border: '1px solid #ffe58f',
          borderRadius: '4px',
          color: '#d4380d',
          fontWeight: 'bold',
          fontSize: '14px'
        }}>
          Editing existing inspection — Installation, Lifter, and Plate fields are locked.
        </div>
      )} */}
      <div className="table-container">
        <table>
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index} colSpan={header.colspan}>
                  {header.label}
                </th>
              ))}
            </tr>
            <tr>
              {subHeaders.map((header, index) => (
                index != 0 ?
                  selectedColumns.includes(columnHeaders[index - 1]?.label) ? (
                    <th key={index} className={header.className}>
                      {header.label}
                    </th>
                  ) : null
                  :
                  <th key={index} className={header.className}>
                    {header.label}
                    {/* <input type='checkbox' name="fill_all" onChange={fillTextboxes} /> */}
                  </th>
              ))}
            </tr>
            <tr>
              <th key={0}>{''}</th>
              {columnHeaders.map((header, index) =>
                selectedColumns.includes(header.label) ? (
                  <th key={index + 1}>{header.label}</th>
                ) : null
              )}
            </tr>
          </thead>
          <tbody>
            {keyValueData.map((row, index) => (
              <tr key={`kv-${index}`}>
                <td><HeaderWithInfo label={row.key} /></td>
                {row.values.map((value, valIndex) =>
                  selectedColumns.includes(columnHeaders[valIndex]?.label) ? (
                    <td key={`kv-val-${index}-${valIndex}`} className="text-center">
                      <input
                        type="number"
                        value={value}
                        onChange={(e) => handleKeyValueChange(index, valIndex, e)}
                        className="inline-input"
                      />
                    </td>
                  ) : null
                )}
              </tr>
            ))}
            <tr>
              <td colSpan="22" className="section-header">
                Operating Details
              </td>
            </tr>
            {operatingDetailsData.map((row, index) => (
              <tr key={`op-${index}`}>
                <td><HeaderWithInfo label={row.key} /></td>
                {row.values.map((value, valIndex) => {
                  const columnLabel = columnHeaders[valIndex]?.label;
                  const isSelected = selectedColumns.includes(columnLabel);
                  if (!isSelected) return null;

                  const inputKey = `input-op-${index}-${valIndex}-${columnLabel}`;
                  const tdKey = `td-op-${index}-${valIndex}-${columnLabel}`;

                  return (
                    <td key={tdKey} className="text-center">
                      <input
                        key={inputKey}
                        type={row.key.includes('Date') ? 'date' : 'number'}
                        value={value}
                        max={row.key.includes('Date') ? inspection_date : undefined}
                        onChange={(e) => handleOperatingDetailsChange(index, valIndex, e)}
                        className="inline-input text-center"
                        // ← ONLY disable if column was in original data
                        {...(index < 2 ? getInputProps('installation', columnLabel) : null)}
                      />
                    </td>
                  );
                })}
              </tr>
            ))}
            <tr>
              <td colSpan="22" className="section-header">
                Lifter Details
              </td>
            </tr>
            {lifterPlateDetails.map((row, index) => (
              <tr key={`lft-${index}`}>
                <td><HeaderWithInfo label={row.key} /></td>
                {row.values.map((value, valIndex) => {
                  // DECLARE columnLabel HERE — THIS IS THE KEY FIX
                  const columnLabel = columnHeaders[valIndex]?.label;
                  const isSelected = selectedColumns.includes(columnLabel);
                  if (!isSelected) return null;

                  // Unique keys to prevent React DOM reuse
                  const tdKey = `td-lft-${index}-${valIndex}-${columnLabel}`;
                  const inputKey = `input-lft-${index}-${valIndex}-${columnLabel}`;

                  return (
                    <td key={tdKey} className="text-center">
                      {row.key === 'Lifter width' && lifterDataMap ? (
                        <select
                          key={inputKey}
                          value={value}
                          onChange={(e) => handleLifterPlateDetailsChange(index, valIndex, e)}
                          className="inline-input"
                          {...getInputProps('lifter', columnLabel)}
                        >
                          {Object.keys(lifterDataMap).map((width) => (
                            <option key={width} value={width}>
                              {width}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <input
                          key={inputKey}
                          type="number"
                          value={value}
                          onChange={(e) => handleLifterPlateDetailsChange(index, valIndex, e)}
                          className="inline-input"
                          {...getInputProps('lifter', columnLabel)}
                        />
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
            <tr>
              <td colSpan="22" className="section-header">
                Plate Details
              </td>
            </tr>
            {plateDetails.map((row, index) => (
              <tr key={`pd-${index}`}>
                <td><HeaderWithInfo label={row.key} /></td>
                {row.values.map((value, valIndex) => {
                  // DECLARE columnLabel HERE — THIS IS THE KEY FIX
                  const columnLabel = columnHeaders[valIndex]?.label;
                  const isSelected = selectedColumns.includes(columnLabel);
                  if (!isSelected) return null;

                  // Unique keys to prevent React DOM reuse
                  const tdKey = `td-pd-${index}-${valIndex}-${columnLabel}`;
                  const inputKey = `input-pd-${index}-${valIndex}-${columnLabel}`;

                  return (
                    <td key={tdKey} className="text-center">
                      <input
                        key={inputKey}
                        type="number"
                        value={value}
                        onChange={(e) => handlePlateDetailsChange(index, valIndex, e)}
                        className="inline-input"
                        {...getInputProps('plate', columnLabel)}
                      />
                    </td>
                  );
                })}
              </tr>
            ))}
            <tr>
              <td colSpan="22" className="section-header">
                Plate Measurement
              </td>
            </tr>
            {measurementData && measurementData.map((row, index) => (
              <tr key={`m-${index}`}>
                <td><HeaderWithInfo label={row.key} /></td>
                {row.values.map((value, valIndex) =>
                  selectedColumns.includes(columnHeaders[valIndex]?.label) ? (
                    <td key={`m-val-${index}-${valIndex}`} className="text-center">
                      <input
                        type="number"
                        value={value}
                        onChange={(e) => handleMeasurementChange(index, valIndex, e)}
                        className="inline-input text-center"
                      />
                    </td>
                  ) : null
                )}
              </tr>
            ))}
            {measuredDistance && measuredDistance.map((row, index) => (
              <tr key={`msd-${index}`}>
                <td><HeaderWithInfo label={row.key} /></td>
                {row.values.map((value, valIndex) =>
                  selectedColumns.includes(columnHeaders[valIndex]?.label) ? (
                    <td key={`msd-val-${index}-${valIndex}`} className="text-center">
                      <input
                        type="number"
                        value={value}
                        onChange={(e) => handleMeasuredDistanceChange(index, valIndex, e)}
                        className="inline-input"
                      />
                    </td>
                  ) : null
                )}
              </tr>
            ))}
            <tr>
              <td colSpan="22" className="section-header">
                Lifter Measurement
              </td>
            </tr>
            {lifterMeasurementData.map((row, index) => (
              <tr key={`lm-${index}`}>
                <td><HeaderWithInfo label={row.key} /></td>
                {row.values.map((value, valIndex) => {
                  const isDisabled = disabledMap[`${index}-${valIndex}`];
                  return (
                    selectedColumns.includes(columnHeaders[valIndex]?.label) ? (
                      <td key={`lm-val-${index}-${valIndex}`} className="text-center">
                        <input
                          type="number"
                          value={isDisabled ? 0 : value}
                          className="inline-input text-center"
                          readOnly={isDisabled}
                          onChange={(e) => handleLifterMeasurementChange(index, valIndex, e)}
                          style={isDisabled ? { backgroundColor: '#f0f0f0', color: '#888' } : {}}
                        />
                      </td>
                    ) : null
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>

      </div>
      <div>
        Notes:
        <textarea
          rows="2"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          style={{ width: '100%', marginTop: '10px' }}
        ></textarea>
      </div>
      <div>

        <button className="button" onClick={exportDataAsJson}>
          Generate Charts
        </button>
        <button className="button reset-button" onClick={resetTablesData}>
          RESET
        </button>
      </div>

      {Object.keys(chartData).length > 0 && (
        <>
          <ChartPDFExporter
            chartData={chartData}
            options={options}
            inspectionData={{ ...inspectionData, notes }}
            recentSummary={recentSummary}
            dataByColumn={dataByColumn}
            handleRowsChange={handleRowsChange}
            wearRows={wearRows}
          />


        </>
      )}
    </div>
  );
};

export default App;